export enum SignUpSteps {
  MOBILE_VERIFICATION_STEP = "Mobile Verification",
  PERSONAL_DETAILS_STEP = "Personal Details",
  ZENITH_ACCOUNT_STEP = "Zenith Account",
  PHOTO_VERIFICATION_STEP = "Photo Verification",
  BUSINESS_INFORMATION_STEP = "Additional Information",
  SELFIE_VERIFICATION_STEP = "Selfie Verification",
  BUSINESS_INFO_STEP = "Business Information",
}

export const defaultSteps = [
  {
    stepName: SignUpSteps.PERSONAL_DETAILS_STEP,
  },
  {
    stepName: SignUpSteps.PHOTO_VERIFICATION_STEP,
  },
  {
    stepName: SignUpSteps.BUSINESS_INFORMATION_STEP,
  },
];

export const mismatchSteps = [
  {
    stepName: SignUpSteps.PERSONAL_DETAILS_STEP,
  },
  {
    stepName: SignUpSteps.PHOTO_VERIFICATION_STEP,
  },
  {
    stepName: SignUpSteps.BUSINESS_INFORMATION_STEP,
  },
];

export const businessSteps = [
  { stepName: SignUpSteps.PERSONAL_DETAILS_STEP },
  { stepName: SignUpSteps.SELFIE_VERIFICATION_STEP },
  { stepName: SignUpSteps.BUSINESS_INFO_STEP },
];

export const existingAccountSteps = [
  {
    stepName: SignUpSteps.ZENITH_ACCOUNT_STEP,
  },
  {
    stepName: SignUpSteps.PHOTO_VERIFICATION_STEP,
  },
  {
    stepName: SignUpSteps.BUSINESS_INFORMATION_STEP,
  },
];
